module.exports = __webpack_public_path__ + "img/yinheBg.62ad91cb.jpg";